import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <span>{{this.label}}</span>
*/
{
  "id": "mbaZSrRD",
  "block": "[[[10,1],[12],[1,[30,0,[\"label\"]]],[13]],[],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/create-color-row.hbs",
  "isStrictMode": false
});